import { useState } from "react";
import { FaHamburger } from 'react-icons/fa';
import { AiOutlineClose } from 'react-icons/ai';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import useMediaQuery from "../hooks/useMediaQuery";

import { motion } from 'framer-motion';
import { fadeIn } from '../variants';

import HeroLogo from '../assets/img/tcp.png';

const Link = ({ page, selectedPage, setSelectedPage}) => {
  const lowerCasePage = page.toLowerCase();
  return (
    <AnchorLink
    className={`${selectedPage === lowerCasePage ? 'text-black lg:text-accent' : ''}
     hover:text-yellow-300 transition duration-500`}
     href={`#${lowerCasePage}`}
     onClick={() => setSelectedPage(lowerCasePage)}
    >
      {page}
    </AnchorLink>
  );
};

const Nav = ({isTopOfPage, selectedPage, setSelectedPage}) => {
  const [isMenuToggled, setIsMenuToggled] = useState(false);
  const isAboveSmallScreens = useMediaQuery('(min-width: 1080px)');
  const navBackground = isTopOfPage ? '' : 'bg-black bg-opacity-90';

  return(
    <nav className={`${navBackground} z-40 w-full fixed top-0 py-6`}>
      <div className="flex items-center justify-between mx-auto w-5/6">
      <AnchorLink href="#howdy"><img className='w-[70px] h-[40px]' src={HeroLogo} alt='#' /></AnchorLink>

      {isAboveSmallScreens ? (
        <div className="flex justify-between gap-6 text-base font-bold">
          <Link
          page='howdy'
          selectedPage={selectedPage}
          setSelectedPage={setSelectedPage}
          />

          <Link
          page='wanna know about us?'
          selectedPage={selectedPage}
          setSelectedPage={setSelectedPage}
          />

          <Link
          page='our team'
          selectedPage={selectedPage}
          setSelectedPage={setSelectedPage}
          />

          <Link
          page='menu'
          selectedPage={selectedPage}
          setSelectedPage={setSelectedPage}
          />

          <Link
          page='write us'
          selectedPage={selectedPage}
          setSelectedPage={setSelectedPage}
          />

          <Link
          page='photo book'
          selectedPage={selectedPage}
          setSelectedPage={setSelectedPage}
          />

          <Link
          page='testimonial'
          selectedPage={selectedPage}
          setSelectedPage={setSelectedPage}
          />

          <a className="text-white hover:text-red-600" href="tel:+94716418542">+94 71 641 8542</a>
        </div>
      ) : (
      <button onClick={() => setIsMenuToggled(!isMenuToggled)}>
        <FaHamburger size={40} color="white"/>
      </button>
      )}

      {!isAboveSmallScreens && isMenuToggled && (
        <motion.div variants={fadeIn('left', 'tween', 0.1, 0.6)}
        initial='hidden'
        whileInView={'show'}
        viewport={{once: false, amount: 0.2}}
        className="fixed right-0 bottom-0 h-full w-3/4 bg-accent">
          <div className="flex justify-end p-10">
            <button onClick={() => setIsMenuToggled(!isMenuToggled)}>
              <AiOutlineClose size={40} color="white"/>
            </button>
          </div>

          <div className="flex flex-col gap-7 ml-[20%] text-2xl text-white">
            <Link
            page='howdy'
            selectedPage={selectedPage}
            setSelectedPage={setSelectedPage}
            />

            <Link
            page='wanna know about us?'
            selectedPage={selectedPage}
            setSelectedPage={setSelectedPage}
            />

            <Link
            page='our team'
            selectedPage={selectedPage}
            setSelectedPage={setSelectedPage}
            />

            <Link
            page='menu'
            selectedPage={selectedPage}
            setSelectedPage={setSelectedPage}
            />

            <Link
            page='write us'
            selectedPage={selectedPage}
            setSelectedPage={setSelectedPage}
            />

            <Link
            page='photo book'
            selectedPage={selectedPage}
            setSelectedPage={setSelectedPage}
            />

            <Link
            page='testimonial'
            selectedPage={selectedPage}
            setSelectedPage={setSelectedPage}
            />
            
            <a className="text-white hover:text-red-600" href="tel:+94716418542">+94 71 641 8542</a>
          </div>

        </motion.div>
      )}
      </div>
    </nav>
  );
};

export default Nav;